(function() {
    'use strict';

    angular
        .module('app')
        .controller('loginForceEditPwdController', loginForceEditPwdController);

    function loginForceEditPwdController(sysCode, loginService, $location, e2eService,$rootScope) {
        var vm = this;
        vm.submit = submit;
        vm.autoFill = autoFill;

        onInit();

        function onInit() {
            vm.data = {};
        }

        function submit() {
            vm.confirmPwd = vm.data.newPwd !== vm.data.confirmPwd;
            if (!vm.confirmPwd) {
                vm.data.sysCode = sysCode;
                vm.data.token = sessionStorage.getItem('token');
                loginService.modifyUserPassword(vm.data).then(function(data) {
                    if (data) {
                        removeSsoInfo();
                        toastr.success($rootScope.translate.commonEditPwdSuccess);
                        $location.path('/login');
                    }
                });
            }
        }

        function autoFill() {
            e2eService.forceEditPwd(vm.data);
        }
    }
})();